import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { LoginService } from 'src/app/core/services/login.service';
import { PolicyRoutes } from 'src/app/core/model/dataModels/menuData';
import { SnackBarService } from '../../snack-bar/snack-bar.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate 
{
    constructor(private _router: Router,
        public appService: AppService,
        public loginService: LoginService,
        private snackBar: SnackBarService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean 
    {
        if(state.url == "/login") { return true; }
        else if (state.url.includes("/index.html?")) { this.appService.tokenOAuth = next.queryParams.tokenOAuth; return true; }
        else if (state.url.includes("/login?tokenOAuth")) {  this.appService.tokenOAuth = next.queryParams.tokenOAuth; return true; }
        else if (state.url.includes("/login?errorLogin")) { this.appService.loginError = true; return true; }
        this.appService.checkLogged();
        if (this.appService.isLogged) 
        {
            if(state.url.includes("home")) { return true; }
            const roleId = parseInt(this.appService.getRolesAndPermisions());
            const allpolicies = this.appService.getPolicies() as PolicyRoutes[];
            const policy = allpolicies.find(p=> p.component == next.data.code);
            if (policy) {  if(policy.roles.includes(roleId)) { return true; } }

            setTimeout(()=> { this.snackBar.error('Messages.RouterAuthError');})
                this._router.navigate(['/home']);
                return false;
        }
        else { this._router.navigate(['/login']); return false; }
    }
}
